import React from 'react';
import { Modal, Typography } from '@ann/web-components';
import { ModalBodyContent, MessageText } from './ReactivateWorkspace.styled';

const ReactivateWorkspace = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false
}) => {
  const title = 'Reactivate Workspace';
  const message = (
    <>
      Reactivating this workspace will restore access for all users and resume its active processes.
      <br />
      Are you sure you want to continue?
    </>
  );

  const handleClose = () => {
    if (!isLoading) {
      onClose();
    }
  };

  const handleConfirm = () => {
    if (!isLoading && onConfirm) {
      onConfirm();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} width="900px" size="medium">
      <Modal.Header>
        <Modal.Header.Title/>      
      </Modal.Header>
      <Modal.Body>
        <ModalBodyContent>
          <MessageText>
            <Typography category="title" size="medium" weight="bold">
              {title}
            </Typography>
            <Typography category="body" size="medium" weight="regular" color="body">
              {message}
            </Typography>
          </MessageText>
        </ModalBodyContent>
      </Modal.Body>
      <Modal.Actions align="center">
        <Modal.Button
          label="Cancel"
          onClick={handleClose}
          type="secondary"
          disabled={isLoading}
        />
        <Modal.Button
          label="Reactivate Workspace"
          onClick={handleConfirm}
          type="primary"
          disabled={isLoading}
          isLoading={isLoading}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default ReactivateWorkspace;

